import { render, staticRenderFns } from "./pipelines_artifacts.vue?vue&type=template&id=65400aa4&scoped=true"
import script from "./pipelines_artifacts.vue?vue&type=script&lang=js"
export * from "./pipelines_artifacts.vue?vue&type=script&lang=js"
import style0 from "./pipelines_artifacts.vue?vue&type=style&index=0&id=65400aa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65400aa4",
  null
  
)

export default component.exports